import { render, staticRenderFns } from "./DetailsCosts.vue?vue&type=template&id=f89b63d0&scoped=true&"
import script from "./DetailsCosts.vue?vue&type=script&lang=ts&"
export * from "./DetailsCosts.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsCosts.vue?vue&type=style&index=0&id=f89b63d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89b63d0",
  null
  
)

export default component.exports